import { useAtomValue } from "jotai";
import { LoggedUserAtom } from "../../main/state/globalState";

const useUser = () => {
  return useAtomValue(LoggedUserAtom);
};

export default useUser;
